import { render } from "./DisplayDocs.vue?vue&type=template&id=4a27424b"
import script from "./DisplayDocs.vue?vue&type=script&lang=js"
export * from "./DisplayDocs.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/recopick-docs-static-prd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__